/* Ivy Fleur - Montleigh-style helpers: AJAX add-to-cart + cart drawer labels */
(function () {
  'use strict';

  // Add a variant to the cart and open the theme's cart drawer (falls back to /cart).
  async function addToCart(variantId, quantity) {
    const body = {
      items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add to bag');
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(Object.assign({}, data.items[0], { sections: data.sections }));
      syncDrawer();
    } else {
      window.location.href = '/cart';
    }
    return data;
  }

  // Montleigh drawer labels: "Bag • N" heading, savings line and "Checkout • £total" button.
  function syncDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      let count = 0;
      drawer.querySelectorAll('.cart-item .quantity__input').forEach(function (input) {
        count += parseInt(input.value || '0', 10) || 0;
      });
      const label = 'Bag \u2022 ' + count;
      const textNode = Array.prototype.find.call(heading.childNodes, function (n) {
        return n.nodeType === 3 && n.textContent.trim() !== '';
      });
      if (textNode && textNode.textContent.trim() !== label) textNode.textContent = label + ' ';
    }

    // The theme renders an optional "Savings" row before the "Total" row; the total is always the last amount.
    const amounts = drawer.querySelectorAll('.cart-drawer__totals .cart-drawer__totals__row__money');
    const total = amounts.length ? amounts[amounts.length - 1].textContent.trim() : '';
    const savings = amounts.length > 1 ? amounts[0].textContent.trim() : '';

    const btnLabel = drawer.querySelector('#CartDrawer-Checkout .button__label');
    if (total && btnLabel) {
      const text = 'Checkout \u2022 ' + total;
      if (btnLabel.textContent.trim() !== text) btnLabel.textContent = text;
    }

    // Promotional savings copy stays hidden while bundle offers are inactive.
    const row = drawer.querySelector('.ivy-ml-savings');
    if (row) row.remove();
  }

  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    syncDrawer();
    let queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncDrawer();
      });
    }).observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value'] });
    drawer.addEventListener('change', syncDrawer);
  }

  window.IvyML = window.IvyML || {};
  window.IvyML.addToCart = addToCart;
  window.IvyML.syncDrawer = syncDrawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
